// extracted by mini-css-extract-plugin
var _1 = "WireframeEditor_canvas__U5TrR";
var _2 = "WireframeEditor_closeButton__l8quV";
var _3 = "WireframeEditor_conflict__v0Xl+";
var _4 = "WireframeEditor_conflictMessage__6YkaJ";
var _5 = "WireframeEditor_loader__-Uzcf";
var _6 = "WireframeEditor_message__wIgXF";
var _7 = "WireframeEditor_modal__CkDDB";
var _8 = "WireframeEditor_nameInput__b2XS6";
var _9 = "WireframeEditor_reloadButton__tNaoR";
var _a = "WireframeEditor_saveButton__CIfy2";
var _b = "WireframeEditor_status__oc74w";
var _c = "WireframeEditor_toolbar__qzWbx";
var _d = "WireframeEditor_wrapper__Dl3sH";
export { _1 as "canvas", _2 as "closeButton", _3 as "conflict", _4 as "conflictMessage", _5 as "loader", _6 as "message", _7 as "modal", _8 as "nameInput", _9 as "reloadButton", _a as "saveButton", _b as "status", _c as "toolbar", _d as "wrapper" }
